import { useSyncExternalStore } from 'react'

const supported = () => typeof window !== 'undefined' && typeof window.matchMedia === 'function'

/** True when the media query matches; re-renders as it changes. False where matchMedia is missing (tests). */
export const useMediaQuery = (query: string): boolean =>
  useSyncExternalStore(
    (cb) => {
      if (!supported()) return () => {}
      const mq = window.matchMedia(query)
      mq.addEventListener('change', cb)
      return () => mq.removeEventListener('change', cb)
    },
    () => supported() && window.matchMedia(query).matches,
    () => false,
  )
